/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PathologyStrictHttpResponse } from '../../pathology-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestDataModel } from '../../models/request-data-model';

export interface PathologyInitializePathologyRequestPost$Params {
      body?: RequestDataModel
}

export function pathologyInitializePathologyRequestPost(http: HttpClient, rootUrl: string, params?: PathologyInitializePathologyRequestPost$Params, context?: HttpContext): Observable<PathologyStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, pathologyInitializePathologyRequestPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PathologyStrictHttpResponse<void>;
    })
  );
}

pathologyInitializePathologyRequestPost.PATH = '/Pathology/InitializePathologyRequest';
